<template>
  <div class="ni-app-submissions-wrapper">
    <div class="ni-submissions-table-wrapper" v-if="showSubmissionsTableView">
      <div class="deployment-alert-message" v-show="showDeploymentAlert">
        {{ deploymentAlert }}
      </div>
      <div>
        <h5 class="ni-app-submission-top-bar">
          <b-field>
            <b-select
              v-model="defaultPageView"
              @input="loadView(defaultPageView)"
              v-on:load.native="getMySubmissions('A')"
              size="is-medium"
            >
              <option value="My Submission Queue">My Submission Queue</option>
              <option value="View All Submissions">View All Submissions</option>
              <option v-show="showSystemAdmin" value="System Admin Functions"
                >System Admin Functions</option
              >
              <option
                v-show="showErroredMainFrameItems"
                value="Errored Mainframe Items"
                >Errored Mainframe Items</option
              ><option v-show="superUserAccess" value="Super User Functions"
                >Super User Functions</option
              >
              <option
                v-show="loginRole === 4"
                value="Proposition 65 Existing Items"
                >Proposition 65 Existing Items</option
              >
            </b-select>
          </b-field>
          <b-button
            type="is-info"
            class="ni-app-delete-errored-items"
            v-show="
              showErroredMainFrameItems &&
                defaultPageView === 'Errored Mainframe Items'
            "
            @click="markErroredItemsDelete"
            :disabled="!enableMFButtons"
            >Mark Selected Delete</b-button
          >
          <b-button
            type="is-info"
            class="ni-app-delete-errored-items"
            v-show="
              showErroredMainFrameItems &&
                defaultPageView === 'Errored Mainframe Items'
            "
            @click="deleteAllBySubmissionId"
            :disabled="!enableMFButtons"
            >Delete All</b-button
          >
          <b-button
            v-show="
              showErroredMainFrameItems &&
                defaultPageView === 'Errored Mainframe Items'
            "
            class="ni-app-delete-errored-items"
            type="is-info"
            @click="undoDeleteBySubmissionId"
            >Undo Delete
          </b-button>
          <b-button
            v-show="
              showErroredMainFrameItems &&
                defaultPageView === 'Errored Mainframe Items'
            "
            class="ni-app-delete-errored-items undo-delete-mf-items"
            type="is-info"
            @click="resubmitErroredItems"
            :disabled="disableResubmitBtn"
            >Resubmit
          </b-button>
          <b-button
            type="is-info"
            class="ni-app-delete-errored-items"
            v-show="
              showErroredMainFrameItems &&
                defaultPageView === 'Errored Mainframe Items'
            "
            @click="downloadRecycledItems"
            >Download
          </b-button>
          <b-upload
            v-show="
              showErroredMainFrameItems &&
                defaultPageView === 'Errored Mainframe Items'
            "
            class="ni-app-delete-errored-items"
            :disabled="!enableMFButtons"
            v-model="file"
            @input="uploadFailedMFItems"
          >
            <a class="button is-info">
              <span>Upload</span>
            </a>
          </b-upload>
        </h5>
      </div>
      <b-message type="is-danger" v-show="showValidationErrorMessage">
        {{ validationErrorDescription }}
      </b-message>
      <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
      <b-button
        type="is-danger is-light"
        outlined
        class="view-all-custom-filter-applied"
        v-show="viewAllFilterApplied"
      >
        Custom Filter Applied
      </b-button>
      <!--      Filter wrapper for My Submissions Page      -->
      <div v-show="defaultPageView === 'My Submission Queue'">
        <div class="my-submissions-filter-wrapper">
          <b-dropdown aria-role="menu" trap-focus class="my-submissions-filter">
            <button class="button is-info is-outlined" slot="trigger">
              <span>Filter Submissions By</span>
            </button>

            <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
              <b-field label="Submission Id">
                <b-input
                  type="text"
                  clsss="search-box"
                  v-model="filterMySubmissionsId"
                >
                </b-input>
              </b-field>
              <b-field label="Vendor ID"
                ><b-input v-model="filterMySubmissionsVnId"></b-input></b-field
              ><b-field label="Vendor Name"
                ><b-input v-model="filterMySubmissionsVnName"></b-input
              ></b-field>
              <b-field label="Priority">
                <b-select expanded v-model="filterMySubmissionsPriority">
                  <option value="Urgent">Urgent</option>
                  <option value="Normal">Normal</option>
                </b-select>
              </b-field>
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            type="is-info"
            outlined
            @click="getMySubmissions('A')"
            class="filter-buttons"
          >
            Apply Filter
          </b-button>
          <b-button
            type="is-info"
            outlined
            @click="
              resetMySubmissionsFilter();
              getMySubmissions('A');
            "
            class="filter-buttons"
          >
            Reset Filter
          </b-button>
        </div>
      </div>
      <!--      Pagination wrapper for My Submissions Page      -->
      <div v-show="defaultPageView === 'My Submission Queue'">
        <div class="pagination-wrapper">
          <div class="pagination-header">
            <b-button
              v-show="mySubmissionsShowPreviousButton"
              @click="
                mySubmissionsPageIndex = mySubmissionsPageIndex - 1;
                getMySubmissions('A');
              "
              >Previous</b-button
            >
            <b-button
              class="apply-filter"
              v-show="mySubmissionsShowFirstButton"
              @click="
                mySubmissionsPageIndex = 1;
                getMySubmissions('A');
              "
              >First</b-button
            >
            <span class="page-index"
              >{{ mySubmissionsMinPageIndex }} to
              {{ mySubmissionsMaxPageIndex }} of
              {{ mySubmissionsTotalResults }}</span
            >
            <b-button
              v-show="mySubmissionsShowLastButton"
              @click="
                mySubmissionsPageIndex = mySubmissionsTotalPages;
                getMySubmissions('A');
              "
              >Last</b-button
            >
            <b-button
              class="apply-filter"
              v-show="mySubmissionsShowNextButton"
              @click="
                mySubmissionsPageIndex = mySubmissionsPageIndex + 1;
                getMySubmissions('A');
              "
              >Next</b-button
            >
            <span class="page-navigator" v-show="mySubmissionsTotalResults > 10"
              ><span class="show-text">Show</span
              ><b-select
                class="page-display-number"
                v-model="mySubmissionsNumberOfItemsPerPage"
                @input="
                  mySubmissionsPageIndex =
                    Math.floor(
                      mySubmissionsMinPageIndex /
                        mySubmissionsNumberOfItemsPerPage
                    ) + 1;
                  getMySubmissions('A');
                "
                ><option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </b-select></span
            >
          </div>
        </div>
      </div>
      <!--      Filter wrapper for View All Submissions Page     -->
      <div v-show="showAllTable">
        <div class="view-all-filter-wrapper" v-show="showViewAllFilter">
          <b-dropdown
            aria-role="menu"
            trap-focus
            class="view-all-submissions-filter"
          >
            <button class="button is-info is-outlined" slot="trigger">
              <span>Filter Submissions By</span>
            </button>

            <b-dropdown-item aria-role="menu-item" :focusable="false" custom
              ><b-field label="Submission ID"
                ><b-input v-model="filterSubmissionId"></b-input
              ></b-field>
              <b-field label="Vendor ID"
                ><b-input v-model="filterVendorId"></b-input></b-field
              ><b-field label="Vendor Name"
                ><b-input v-model="filterVendorName"></b-input
              ></b-field>
              <b-field label="Status"
                ><b-select v-model="filterStatus"
                  ><option value=""> </option> <option value="D">Draft</option
                  ><option value="W1">Re-work for Supplier</option>
                  <option value="W2">Re-work for Product Management</option>
                  <option value="N">Cancelled</option
                  ><option value="A">Active</option
                  ><option value="U">Upload</option>
                  <option value="P">Processed</option>
                  <option value="R">Rejected</option></b-select
                ></b-field
              >
              <b-field label="Created Date"
                ><b-datepicker
                  v-model="filterDateRange"
                  :min-date="minAppDate"
                  range
                ></b-datepicker
              ></b-field>
              <b-field label="Created By"
                ><b-input v-model="filterCreatedBy"></b-input
              ></b-field>
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            type="is-info"
            outlined
            @click="getAllSubmissions"
            class="filter-buttons"
          >
            Apply Filter
          </b-button>
          <b-button
            type="is-info"
            outlined
            @click="
              resetSubmissionsFilter();
              getAllSubmissions();
            "
            class="filter-buttons"
          >
            Reset Filter
          </b-button>
          <div class="submission-id-search">
            <b-field>
              <b-input
                placeholder="Enter Submission Id"
                type="text"
                clsss="search-box"
                v-model="searchSubmissionId"
              >
              </b-input>
              <b-button
                class="search-button"
                @click="getAllSearchSubmissions"
                :disabled="searchSubmissionId.trim().length === 0"
                type="is-info"
                outlined
              >
                Search
              </b-button>
            </b-field>
          </div>
        </div>
      </div>
      <!--      Pagination wrapper for View All Submissions Page    -->
      <div v-show="showAllTable">
        <div class="pagination-wrapper">
          <div class="pagination-header">
            <b-button
              v-show="showPreviousButton"
              @click="
                pageIndex = pageIndex - 1;
                resetSearchSubmission();
                getAllSubmissions();
              "
              >Previous</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showFirstButton"
              @click="
                pageIndex = 1;
                resetSearchSubmission();
                getAllSubmissions();
              "
              >First</b-button
            >
            <span class="page-index"
              >{{ minPageIndex }} to {{ maxPageIndex }} of
              {{ totalResults }}</span
            >
            <b-button
              v-show="showLastButton"
              @click="
                pageIndex = totalPages;
                resetSearchSubmission();
                getAllSubmissions();
              "
              >Last</b-button
            >
            <b-button
              class="apply-filter"
              v-show="showNextButton"
              @click="
                pageIndex = pageIndex + 1;
                resetSearchSubmission();
                getAllSubmissions();
              "
              >Next</b-button
            >
            <span class="page-navigator" v-show="totalResults > 10"
              ><span class="show-text">Show</span
              ><b-select
                class="page-display-number"
                v-model="numberOfItemsPerPage"
                @input="
                  pageIndex =
                    Math.floor(minPageIndex / numberOfItemsPerPage) + 1;
                  getAllSubmissions();
                "
                ><option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </b-select></span
            >
          </div>
        </div>
      </div>
      <b-message
        class="column ni-submissions-view-error-message"
        type="is-danger"
        v-show="showSubmissionsViewError"
        size="is-small"
        aria-close-label="Close notification"
      >
        {{ submissionsErrorText }}
      </b-message>
      <div
        class="new-item-submissions-table-wrapper"
        v-show="showSubmissionsTable"
      >
        <b-table
          class="my-submissions-queue"
          :data="data"
          :columns="columns"
          @click="checkBuildApi"
          focusable
          v-show="defaultPageView === 'My Submission Queue'"
        >
        </b-table>
        <b-table
          class="view-all-submissions-queue"
          :data="data"
          :columns="viewAllColumns"
          @click="checkBuildApi"
          focusable
          v-show="defaultPageView === 'View All Submissions'"
        >
        </b-table>
      </div>
      <div
        class="new-item-submissions-system-admin-wrapper"
        v-show="defaultPageView === 'System Admin Functions'"
      >
        <table class="mainframe-job-table">
          <thead>
            <tr>
              <th>Job Name</th>
              <th>Last Execution Time</th>
              <th>Next Execution Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Mainframe Load Job Trigger</td>
              <td></td>
              <td></td>
              <td>
                <b-button type="is-info" @click="executeQuartzJob"
                  >Execute</b-button
                >
              </td>
            </tr>
            <tr>
              <td class="padding-top-10">Load Recycled Items into New Item</td>
              <td></td>
              <td></td>
              <td class="padding-top-10">
                <b-button type="is-info" @click="executeRecycledItemsJob"
                  >Execute</b-button
                >
              </td>
            </tr>
            <tr>
              <td class="padding-top-10">Generate Cas Upload File</td>
              <td></td>
              <td></td>
              <td class="padding-top-10">
                <b-button type="is-info" @click="executeCasUploadJob"
                  >Execute</b-button
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="new-item-submissions-super-user-wrapper"
        v-show="defaultPageView === 'Super User Functions'"
      >
        <SuperUserFunctionsComponent></SuperUserFunctionsComponent>
      </div>
      <div
        class="new-item-submissions-errored-items-wrapper"
        v-show="defaultPageView === 'Errored Mainframe Items'"
      >
        <ErroredMainframeItemsComponent
          v-if="defaultPageView === 'Errored Mainframe Items'"
          :reloadErroredItems="triggerReloadErroredItems"
          @selectedRowIdsForErroredItems="erroredItemsToMarkDelete"
          @emfActionsBtns="checkEMFBtnAccess"
        ></ErroredMainframeItemsComponent>
      </div>
      <div
        class="new-item-submissions-prop-65-compliance"
        v-show="showProp65ComplianceComponent === true"
      >
        <Prop65ComplianceComponent
          v-if="showProp65ComplianceComponent === true"
        ></Prop65ComplianceComponent>
      </div>
    </div>
    <div class="ni-app-submission-form-import" v-else>
      <SubmissionFormView
        @toggleSubmissionView="onToggleSubmissionViewEvent"
        @refreshGrid="
          data = [];
          getMySubmissions('A');
        "
        @refreshViewAllGrid="
          data = [];
          getAllSubmissions();
        "
      />
    </div>
    <div
      class="columns"
      v-show="
        deleteAllItemsSubmissionById &&
          deleteAllFlag &&
          defaultPageView === 'Errored Mainframe Items'
      "
    ></div>
    <div
      class="columns"
      v-show="
        undoDeleteButtonById &&
          undoDeleteFlag &&
          defaultPageView === 'Errored Mainframe Items'
      "
    ></div>
    <b-modal
      :active.sync="isDeleteAllModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <DeleteAllModal
        @reloadEMF="triggerReloadErroredItems = true"
        @goToHomePage="isDeleteAllModalActive = false"
      ></DeleteAllModal>
    </b-modal>
  </div>
</template>

<script>
import ErroredMainframeItemsComponent from "../components/ErroredMainframeItemsComponent.vue";
import Prop65ComplianceComponent from "../components/Prop65ComplianceComponent.vue";
import SuperUserFunctionsComponent from "../components/SuperUserFunctionsComponent.vue";
import SubmissionFormView from "../views/SubmissionFormView.vue";
import DeleteAllModal from "../components/DeleteAllModal.vue";
import BField from "buefy/src/components/field/Field";
import BSelect from "buefy/src/components/select/Select";
import BDatepicker from "buefy/src/components/datepicker/Datepicker";
import BButton from "buefy/src/components/button/Button";
export default {
  name: "SubmissionsComponent",
  components: {
    BButton,
    BDatepicker,
    BSelect,
    BField,
    SubmissionFormView,
    DeleteAllModal,
    ErroredMainframeItemsComponent,
    Prop65ComplianceComponent,
    SuperUserFunctionsComponent
  },
  data() {
    return {
      isLoading: false,
      defaultPageView: "My Submission Queue",
      columns: [
        { field: "nbrNewItemCrKey", label: "Submission ID" },
        { field: "submissionDesc", label: "Submission Desc" },
        { field: "priority", label: "Priority" },
        { field: "prodCount", label: "Number of Products" },
        { field: "vnName", label: "Vendor Name" },
        { field: "vn", label: "Vendor ID" },
        { field: "dateCreated", label: "Create Date" },
        { field: "nameUser", label: "Created By" },
        { field: "status", label: "Status" }
      ],
      viewAllColumns: [
        { field: "nbrNewItemCrKey", label: "Submission ID" },
        { field: "submissionDesc", label: "Submission Desc" },
        { field: "priority", label: "Priority" },
        { field: "prodCount", label: "Number of Products" },
        { field: "vnName", label: "Vendor Name" },
        { field: "vn", label: "Vendor ID" },
        { field: "currentApproverName", label: "Current Approver Name" },
        { field: "nextApproverName", label: "Next Approver Name" },
        { field: "dateCreated", label: "Create Date" },
        { field: "nameUser", label: "Created By" },
        { field: "status", label: "Status" }
      ],
      vendorColumns: [
        { field: "vendorNumber", label: "Vendor Number" },
        { field: "vendorName", label: "Vendor Name" },
        { field: "mcsCode", label: "MCS Code" },
        { field: "vnCategory", label: "Vendor Category" }
      ],
      data: [],
      file: null,
      loginRole: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").roleKey
        : "",
      validationErrorDescription: "",
      showValidationErrorMessage: false,
      enableMFButtons: true,
      disableResubmitBtn: false,
      rowsToDelete: [],
      triggerReloadErroredItems: false,
      showViewAllFilter: false,
      showSystemAdmin: false,
      superUserAccess: false,
      showErroredMainFrameItems: false,
      showSubmissionsTable: false,
      showSubmissionsViewError: false,
      showDeploymentAlert: false,
      submissionsErrorText: "",
      deploymentAlert: "",
      showSubmissionsTableView: true,
      showAllTable: false,
      showSuperUserFunctionsComponent: false,
      showProp65ComplianceComponent: false,
      showLoading: false,
      filterMySubmissionsId: "",
      filterMySubmissionsVnId: "",
      filterMySubmissionsVnName: "",
      filterMySubmissionsPriority: "",
      mySubmissionsPageIndex: 1,
      mySubmissionsMinPageIndex: "",
      mySubmissionsMaxPageIndex: "",
      mySubmissionsTotalResults: "",
      mySubmissionsTotalPages: "",
      mySubmissionsShowPreviousButton: true,
      mySubmissionsShowNextButton: true,
      mySubmissionsShowFirstButton: true,
      mySubmissionsShowLastButton: true,
      mySubmissionsNumberOfItemsPerPage: 10,
      pageIndex: 1,
      minPageIndex: "",
      maxPageIndex: "",
      totalResults: "",
      totalPages: "",
      showPreviousButton: true,
      showNextButton: true,
      showFirstButton: true,
      showLastButton: true,
      numberOfItemsPerPage: 10,
      searchSubmissionId: "",
      filterSubmissionId: "",
      filterVendorId: "",
      filterVendorName: "",
      filterStatus: "",
      filterDateRange: null,
      filterCreatedBy: "",
      viewAllFilterApplied: false,
      deleteAllItemsSubmissionById: "",
      comments: "",
      deleteAllFlag: true,
      undoDeleteButtonById: "",
      undoDeleteFlag: true,
      isDeleteAllModalActive: false,
      minAppDate: new Date("Jan 01 2020")
    };
  },
  mounted() {
    this.showSubmissionsTable = true;
    this.getMySubmissions("A");
    var userCookie = window.$cookies.get("ni_key");
    // userCookie.systemAdmin === "Y"
    //   ? (this.showSystemAdmin = true)
    //   : (this.showSystemAdmin = false);
    userCookie.roleKey === 6
      ? ((this.showErroredMainFrameItems = true), (this.superUserAccess = true))
      : ((this.showErroredMainFrameItems = false),
        (this.superUserAccess = false));
  },
  methods: {
    loadView(defaultPageView) {
      if (defaultPageView === "My Submission Queue") {
        this.showSubmissionsTable = true;
        this.showViewAllFilter = false;
        this.showAllTable = false;
        this.showSuperUserFunctionsComponent = false;
        this.showProp65ComplianceComponent = false;
        this.getMySubmissions("A");
      } else if (defaultPageView === "System Admin Functions") {
        this.showSubmissionsTable = false;
        this.showViewAllFilter = false;
        this.showAllTable = false;
        this.showSuperUserFunctionsComponent = false;
        this.showProp65ComplianceComponent = false;
      } else if (defaultPageView === "Errored Mainframe Items") {
        this.showSubmissionsTable = false;
        this.showViewAllFilter = false;
        this.showAllTable = false;
        this.showSuperUserFunctionsComponent = false;
        this.showProp65ComplianceComponent = false;
      } else if (defaultPageView === "Super User Functions") {
        this.showSubmissionsTable = false;
        this.showViewAllFilter = false;
        this.showAllTable = false;
        this.showSuperUserFunctionsComponent = true;
        this.showProp65ComplianceComponent = false;
      } else if (defaultPageView === "Proposition 65 Existing Items") {
        this.showSubmissionsTable = false;
        this.showViewAllFilter = false;
        this.showAllTable = false;
        this.showSuperUserFunctionsComponent = false;
        this.showProp65ComplianceComponent = true;
      } else {
        this.showSubmissionsTable = true;
        this.showViewAllFilter = true;
        this.getAllSubmissions();
        this.showAllTable = true;
        this.showSuperUserFunctionsComponent = false;
        this.showProp65ComplianceComponent = false;
      }
    },
    getMySubmissions(status) {
      var submissionsViewComponentScope = this;
      var userCookie = window.$cookies.get("ni_key");
      var requestPayload = {};
      requestPayload.actions = [];
      if (
        this.filterMySubmissionsId ||
        this.filterMySubmissionsVnId ||
        this.filterMySubmissionsVnName ||
        this.filterMySubmissionsPriority
      ) {
        requestPayload.actions.push("Filter");
      }
      requestPayload.filterMap = {};
      if (this.filterMySubmissionsId) {
        requestPayload.filterMap.submissionId = this.filterMySubmissionsId;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterMySubmissionsVnId) {
        requestPayload.filterMap.vn = this.filterMySubmissionsVnId;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterMySubmissionsVnName) {
        requestPayload.filterMap.vnName = this.filterMySubmissionsVnName;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterMySubmissionsPriority) {
        requestPayload.filterMap.priority = this.filterMySubmissionsPriority;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      submissionsViewComponentScope.isLoading = true;
      submissionsViewComponentScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}awaitingMyAttention?networkId=${userCookie.networkId}&status=${status}&pageNbr=${submissionsViewComponentScope.mySubmissionsPageIndex}&pageSize=${submissionsViewComponentScope.mySubmissionsNumberOfItemsPerPage}`,
          requestPayload
        )
        .then(function(response) {
          response.data.startIndex
            ? (submissionsViewComponentScope.mySubmissionsMinPageIndex =
                response.data.startIndex)
            : (submissionsViewComponentScope.mySubmissionsMinPageIndex = 0);
          response.data.endIndex
            ? (submissionsViewComponentScope.mySubmissionsMaxPageIndex =
                response.data.endIndex)
            : (submissionsViewComponentScope.mySubmissionsMaxPageIndex = 0);
          response.data.totalCount
            ? (submissionsViewComponentScope.mySubmissionsTotalResults =
                response.data.totalCount)
            : (submissionsViewComponentScope.mySubmissionsTotalResults = 0);
          response.data.totalPages !== undefined
            ? (submissionsViewComponentScope.mySubmissionsTotalPages =
                response.data.totalPages)
            : (submissionsViewComponentScope.mySubmissionsTotalPages = 0);
          if (response.data.startIndex <= 1) {
            submissionsViewComponentScope.mySubmissionsShowPreviousButton = false;
            submissionsViewComponentScope.mySubmissionsShowFirstButton = false;
          } else {
            submissionsViewComponentScope.mySubmissionsShowPreviousButton = true;
            submissionsViewComponentScope.mySubmissionsShowFirstButton = true;
          }
          if (
            submissionsViewComponentScope.mySubmissionsPageIndex >=
            submissionsViewComponentScope.mySubmissionsTotalPages
          ) {
            submissionsViewComponentScope.mySubmissionsShowNextButton = false;
            submissionsViewComponentScope.mySubmissionsShowLastButton = false;
          } else {
            submissionsViewComponentScope.mySubmissionsShowNextButton = true;
            submissionsViewComponentScope.mySubmissionsShowLastButton = true;
          }
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = false;
          submissionsViewComponentScope.data =
            response.data.psfsNewItemCrTbDTOS;
          //remove previously highlighted row if any
          if (document.querySelector(".highlight-row")) {
            document
              .querySelector(".highlight-row")
              .closest("tr")
              .classList.remove("highlight-row");
          }
          //highlight row matching current search Id
          if (submissionsViewComponentScope.filterMySubmissionsId) {
            for (var row in submissionsViewComponentScope.data) {
              if (
                submissionsViewComponentScope.data[
                  row
                ].nbrNewItemCrKey.toString() ===
                submissionsViewComponentScope.filterMySubmissionsId
              ) {
                document
                  .querySelectorAll(".my-submissions-queue tbody tr")
                  [row].classList.add("highlight-row");
              }
            }
          }
          if (response.data.builtAlert !== undefined) {
            submissionsViewComponentScope.showDeploymentAlert = true;
            submissionsViewComponentScope.deploymentAlert =
              response.data.builtAlert;
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = true;
          submissionsViewComponentScope.submissionsErrorText = `Failed to load My Submission Queue data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`;
        });
    },
    //Todo remove this code after 376 is tested
    getAllSubmissions() {
      var submissionsViewComponentScope = this;
      var userCookie = window.$cookies.get("ni_key");
      var url = "";
      var requestPayload = {};
      requestPayload.actions = [];
      if (
        this.filterSubmissionId ||
        this.filterVendorName ||
        this.filterVendorId ||
        this.filterStatus ||
        this.filterCreatedBy ||
        this.filterDateRange
      ) {
        requestPayload.actions.push("Filter");
      }
      requestPayload.filterMap = {};
      if (this.filterSubmissionId) {
        requestPayload.filterMap.submissionId = this.filterSubmissionId;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterVendorId) {
        requestPayload.filterMap.vn = this.filterVendorId;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterVendorName) {
        requestPayload.filterMap.vnName = this.filterVendorName;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterStatus) {
        requestPayload.filterMap.status = this.filterStatus;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterCreatedBy) {
        requestPayload.filterMap.createdBy = this.filterCreatedBy;
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      if (this.filterDateRange) {
        requestPayload.filterMap.fromDate = this.filterDateRange[0];
        requestPayload.filterMap.toDate = this.filterDateRange[1];
        submissionsViewComponentScope.viewAllFilterApplied = true;
      }
      submissionsViewComponentScope.isLoading = true;
      submissionsViewComponentScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}viewAllSubmissions?networkId=${userCookie.networkId}${url}&pageNbr=${this.pageIndex}&pageSize=${this.numberOfItemsPerPage}`,
          requestPayload
        )
        .then(function(response) {
          response.data.startIndex
            ? (submissionsViewComponentScope.minPageIndex =
                response.data.startIndex)
            : (submissionsViewComponentScope.minPageIndex = 0);
          response.data.endIndex
            ? (submissionsViewComponentScope.maxPageIndex =
                response.data.endIndex)
            : (submissionsViewComponentScope.maxPageIndex = 0);
          response.data.totalCount
            ? (submissionsViewComponentScope.totalResults =
                response.data.totalCount)
            : (submissionsViewComponentScope.totalResults = 0);
          response.data.totalPages !== undefined
            ? (submissionsViewComponentScope.totalPages =
                response.data.totalPages)
            : (submissionsViewComponentScope.totalPages = 0);
          if (response.data.startIndex <= 1) {
            submissionsViewComponentScope.showPreviousButton = false;
            submissionsViewComponentScope.showFirstButton = false;
          } else {
            submissionsViewComponentScope.showPreviousButton = true;
            submissionsViewComponentScope.showFirstButton = true;
          }
          if (
            submissionsViewComponentScope.pageIndex >=
            submissionsViewComponentScope.totalPages
          ) {
            submissionsViewComponentScope.showNextButton = false;
            submissionsViewComponentScope.showLastButton = false;
          } else {
            submissionsViewComponentScope.showNextButton = true;
            submissionsViewComponentScope.showLastButton = true;
          }
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = false;
          submissionsViewComponentScope.searchSubmissionId = "";
          submissionsViewComponentScope.data =
            response.data.psfsNewItemCrTbDTOS;
          //remove previously highlighted row if any
          if (document.querySelector(".highlight-row")) {
            document
              .querySelector(".highlight-row")
              .closest("tr")
              .classList.remove("highlight-row");
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = true;
          submissionsViewComponentScope.submissionsErrorText =
            "Failed to load View All Submissions data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    //view all Submissions based search submissionId
    getAllSearchSubmissions() {
      var submissionsViewComponentScope = this;
      var userCookie = window.$cookies.get("ni_key");
      var requestPayload = {};
      if (this.searchSubmissionId)
        submissionsViewComponentScope.viewAllFilterApplied = true;
      submissionsViewComponentScope.isLoading = true;
      submissionsViewComponentScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}viewAllSubmissions?networkId=${userCookie.networkId}&submissionId=${this.searchSubmissionId}&pageSize=${this.numberOfItemsPerPage}`,
          requestPayload
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          response.data.startIndex
            ? (submissionsViewComponentScope.minPageIndex =
                response.data.startIndex)
            : (submissionsViewComponentScope.minPageIndex = 0);
          response.data.endIndex
            ? (submissionsViewComponentScope.maxPageIndex =
                response.data.endIndex)
            : (submissionsViewComponentScope.maxPageIndex = 0);
          response.data.totalCount
            ? (submissionsViewComponentScope.totalResults =
                response.data.totalCount)
            : (submissionsViewComponentScope.totalResults = 0);
          response.data.totalPages !== undefined
            ? (submissionsViewComponentScope.totalPages =
                response.data.totalPages)
            : (submissionsViewComponentScope.totalPages = 0);
          submissionsViewComponentScope.pageIndex =
            Math.floor(
              submissionsViewComponentScope.minPageIndex /
                response.data.pageSize
            ) + 1;
          if (response.data.startIndex <= 1) {
            submissionsViewComponentScope.showPreviousButton = false;
            submissionsViewComponentScope.showFirstButton = false;
          } else {
            submissionsViewComponentScope.showPreviousButton = true;
            submissionsViewComponentScope.showFirstButton = true;
          }
          if (
            submissionsViewComponentScope.pageIndex >=
            submissionsViewComponentScope.totalPages
          ) {
            submissionsViewComponentScope.showNextButton = false;
            submissionsViewComponentScope.showLastButton = false;
          } else {
            submissionsViewComponentScope.showNextButton = true;
            submissionsViewComponentScope.showLastButton = true;
          }
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = false;
          submissionsViewComponentScope.data =
            response.data.psfsNewItemCrTbDTOS;
          //remove previously highlighted row if any
          if (document.querySelector(".highlight-row")) {
            document
              .querySelector(".highlight-row")
              .closest("tr")
              .classList.remove("highlight-row");
          }
          //highlight row matching current search Id
          if (submissionsViewComponentScope.searchSubmissionId) {
            for (var row in submissionsViewComponentScope.data) {
              if (
                submissionsViewComponentScope.data[
                  row
                ].nbrNewItemCrKey.toString() ===
                submissionsViewComponentScope.searchSubmissionId
              ) {
                document
                  .querySelectorAll(".view-all-submissions-queue tbody tr")
                  [row].classList.add("highlight-row");
              }
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.viewAllFilterApplied = true;
          submissionsViewComponentScope.showSubmissionsViewError = true;
          submissionsViewComponentScope.submissionsErrorText =
            "No matching records found with search string";
        });
    },
    executeQuartzJob() {
      var submissionsViewComponentScope = this;

      submissionsViewComponentScope.isLoading = true;
      submissionsViewComponentScope.$http
        .get(`${process.env.VUE_APP_API_BASE_DOMAIN}executeQuartzJob`)
        .then(function(response) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.$buefy.dialog.alert({
            message: response.data,
            confirmText: "OK",
            type: "is-success"
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = true;
          submissionsViewComponentScope.submissionsErrorText = `Failed to execute action. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`;
        });
    },
    executeRecycledItemsJob() {
      var submissionsViewComponentScope = this;

      submissionsViewComponentScope.isLoading = true;
      submissionsViewComponentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}erroredMainframeItems/recycledItems`
        )
        .then(function(response) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.$buefy.dialog.alert({
            message: response.data,
            confirmText: "OK",
            type: "is-success"
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = true;
          submissionsViewComponentScope.submissionsErrorText =
            "Failed to execute action. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    executeCasUploadJob() {
      var submissionsViewComponentScope = this;
      submissionsViewComponentScope.isLoading = true;
      submissionsViewComponentScope.$http
        .get(`${process.env.VUE_APP_API_BASE_DOMAIN}catCas/createDatFile`)
        .then(function(response) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.$buefy.dialog.alert({
            message: response.data,
            confirmText: "OK",
            type: "is-success"
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionsViewComponentScope.isLoading = false;
          submissionsViewComponentScope.showSubmissionsViewError = true;
          submissionsViewComponentScope.submissionsErrorText =
            "Failed to execute action. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com";
        });
    },
    openEditForm(rowData) {
      var componentScope = this;
      var currentUser = window.$cookies.get("ni_key").networkId;
      componentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}getsupplierinfo/submissionId/${rowData.nbrNewItemCrKey}/${currentUser}`
        )
        .then(function(response) {
          if (response.data.indRowLock === "Y") {
            componentScope.$buefy.dialog.alert({
              message: `Submission ${rowData.nbrNewItemCrKey} is currently locked for upload, please try again later.`,
              confirmText: "OK",
              type: "is-info"
            });
          } else {
            window.$cookies.set("submissionObj", rowData.nbrNewItemCrKey);
            window.$cookies.set("fromTable", componentScope.defaultPageView);
            componentScope.showSubmissionsTableView = false;
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          componentScope.$buefy.dialog.alert({
            message: `Failed to load Submission details with ID ${rowData.nbrNewItemCrKey}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    onToggleSubmissionViewEvent() {
      if (sessionStorage.getItem("rows")) {
        sessionStorage.removeItem("rows");
      }
      this.showSubmissionsTableView = true;
      if (this.defaultPageView === "My Submission Queue") {
        // this.showViewAllFilter = false;
        this.getMySubmissions("A");
      } else if (this.defaultPageView === "Super User Functions") {
        this.showSuperUserFunctionsComponent = true;
      } else {
        this.getAllSubmissions();
      }
    },
    resetMySubmissionsFilter() {
      (this.filterMySubmissionsId = ""),
        (this.filterMySubmissionsVnId = ""),
        (this.filterMySubmissionsVnName = ""),
        (this.filterMySubmissionsPriority = ""),
        (this.viewAllFilterApplied = false);
    },
    resetSubmissionsFilter() {
      (this.filterSubmissionId = ""),
        (this.filterStatus = ""),
        (this.filterVendorId = ""),
        (this.filterVendorName = ""),
        (this.filterDateRange = null),
        (this.filterCreatedBy = ""),
        (this.searchSubmissionId = "");
      this.viewAllFilterApplied = false;
    },
    resetSearchSubmission() {
      this.searchSubmissionId = "";
      this.viewAllFilterApplied = false;
    },
    undoDeleteMFItems() {
      var newItemSubmissionComponentScope = this;
      var userCookie = window.$cookies.get("ni_key");
      this.triggerReloadErroredItems = false;
      this.$http;
      newItemSubmissionComponentScope.triggerReloadErroredItems = false;
      newItemSubmissionComponentScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}mfFailedItems/undoDelete?createdBy=${userCookie.networkId}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Undo Deleted Mainframe Items is Successful`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () =>
              (newItemSubmissionComponentScope.triggerReloadErroredItems = true)
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Failed to Undo Delete. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    uploadFailedMFItems() {
      var newItemSubmissionScope = this;
      this.triggerReloadErroredItems = false;
      var networkId = window.$cookies.get("ni_key").networkId;
      var isUploadFormatValid = /^.*\.(xls|xlsx)$/.test(
        newItemSubmissionScope.file.name
      );
      if (isUploadFormatValid) {
        newItemSubmissionScope.showValidationErrorMessage = false;
        newItemSubmissionScope.validationErrorDescription = "";
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append("file", newItemSubmissionScope.file);
        newItemSubmissionScope.isLoading = true;
        newItemSubmissionScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}excel/erroredMainframeItems/upload?networkId=${networkId}`,
            uploadData,
            args
          )
          .then(function(response) {
            newItemSubmissionScope.isLoading = false;
            newItemSubmissionScope.file = null;
            if (response.data.toLowerCase() === "background") {
              newItemSubmissionScope.$buefy.dialog.alert({
                message: `File is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  newItemSubmissionScope.$emit("toggleSubmissionView", true)
              });
            } else if (response.data.toLowerCase() === "failure") {
              newItemSubmissionScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              newItemSubmissionScope.$buefy.dialog.alert({
                message: `Upload Successful for Failed Mainframe Items.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  (newItemSubmissionScope.triggerReloadErroredItems = true)
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            newItemSubmissionScope.isLoading = false;
            newItemSubmissionScope.$buefy.dialog.alert({
              message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      } else {
        newItemSubmissionScope.showValidationErrorMessage = true;
        newItemSubmissionScope.validationErrorDescription = `${newItemSubmissionScope.file.name} - Invalid file type, system accepts only .xls(x) extension.`;
      }
    },
    erroredItemsToMarkDelete(value) {
      this.rowsToDelete = value;
    },
    deleteAllBySubmissionId() {
      this.triggerReloadErroredItems = false;
      this.isDeleteAllModalActive = true;
    },
    undoDeleteBySubmissionId() {
      this.$buefy.dialog.prompt({
        message: `Please enter the Submission Id to undo deleted items. Enter "All" to undo all the items across the Submissions.`,
        trapFocus: true,
        type: "is-info",
        onConfirm: value => (
          (this.undoDeleteButtonById = value), this.getSubmissionIdToUndo()
        )
      });
    },
    getSubmissionIdToUndo() {
      var newItemSubmissionComponentScope = this;
      newItemSubmissionComponentScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}mfFailedItems/undoDelete?nbrNewItemCrKey=${this.undoDeleteButtonById}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.triggerReloadErroredItems = false;
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Item(s) reverted back Successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () =>
              (newItemSubmissionComponentScope.triggerReloadErroredItems = true)
          });
        });
      newItemSubmissionComponentScope.undoDeleteFlag = false;
    },
    markErroredItemsDelete() {
      if (this.rowsToDelete.length === 0) {
        this.$buefy.dialog.alert({
          message: `Please select at least one item.`,
          confirmText: "OK",
          type: "is-info"
        });
      } else {
        this.$buefy.dialog.prompt({
          message: `A comment is required inorder to delete an Item.`,
          trapFocus: true,
          type: "is-info",
          onConfirm: value => (
            (this.comments = value), this.deleteErroredItems()
          )
        });
      }
    },
    deleteErroredItems() {
      var newItemSubmissionComponentScope = this;
      var ids = newItemSubmissionComponentScope.rowsToDelete;
      newItemSubmissionComponentScope.triggerReloadErroredItems = false;
      newItemSubmissionComponentScope.isLoading = true;
      newItemSubmissionComponentScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}failedMFLoadItems/delete?comments=${this.comments}`,
          ids
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Deleted selected item(s) successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () =>
              (newItemSubmissionComponentScope.triggerReloadErroredItems = true)
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Failed to delete selected item(s). Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    resubmitErroredItems() {
      var newItemSubmissionComponentScope = this;
      var userCookie = window.$cookies.get("ni_key");
      newItemSubmissionComponentScope.triggerReloadErroredItems = false;
      newItemSubmissionComponentScope.isLoading = true;
      newItemSubmissionComponentScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}erroredMainframeItems/resubmit?networkId=${userCookie.networkId}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Resubmitted item(s) successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () =>
              (newItemSubmissionComponentScope.triggerReloadErroredItems = true)
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Failed to resubmit item(s). Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    downloadRecycledItems() {
      var newItemSubmissionComponentScope = this;
      var url = "";
      var filename = "";
      url = `${process.env.VUE_APP_API_BASE_DOMAIN}downloadRecycledItems`;
      filename = "Recycled_Items.xlsx";
      newItemSubmissionComponentScope.isLoading = true;
      newItemSubmissionComponentScope
        .$http({
          url: url,
          method: "GET",
          responseType: "blob"
        })
        .then(function(response) {
          newItemSubmissionComponentScope.isLoading = false;
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `A problem occurred with file download. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    checkEMFBtnAccess(obj) {
      if (obj.enableDataBtns) {
        this.enableMFButtons = true;
      } else {
        this.enableMFButtons = false;
      }
      if (obj.enableResubmitBtn) {
        this.disableResubmitBtn = false;
      } else {
        this.disableResubmitBtn = true;
      }
    },
    checkBuildApi(rowData) {
      var newItemSubmissionComponentScope = this;
      newItemSubmissionComponentScope.isLoading = true;
      newItemSubmissionComponentScope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}isBuildInProgress`,
          method: "GET"
        })
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.isLoading = false;
          if (response.data.toLowerCase() === "yes") {
            //take user to maintainance page
            newItemSubmissionComponentScope.$router.push({
              path: "/maintainancePage"
            });
          } else {
            newItemSubmissionComponentScope.openEditForm(rowData);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `A problem occurred while loading data. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    }
  }
};
</script>

<style scoped></style>
